import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    Observable,
    map,
    of
} from 'rxjs';
import { AuthService } from './auth.service';
import { log } from 'console';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {

  userPermissions$ = new BehaviorSubject<string[]>([]);

  constructor(private http: HttpClient, private authService: AuthService) {
    this.fetchPermissionsFromServer().subscribe((res) => {
      const permissions = res.map((permission: string) =>
        permission.toUpperCase()
      );
      this.userPermissions$.next(permissions);
    });

  }

   fetchPermissionsFromServer(): Observable<any> {
    return this.http
      .get<any>('/api/access/v1/get/user/permissions')
      .pipe(map((res) => res.data));
  }

  hasPermission(permission: string): boolean {
    permission = permission.toUpperCase();
    return this.userPermissions$.getValue().includes(permission);
  }

  hasPermissions(permission: string, permissionsFromServer: string[]): Observable<boolean> {
    // Supposons que vous ayez une liste de permissions de l'utilisateur dans `permissionsFromServer`
    // Vous pouvez utiliser la méthode Array.includes() pour vérifier si la permission est présente
    // console.log('hasPermissions', permission, permissionsFromServer);
    return of(permissionsFromServer.includes(permission.toUpperCase()));
  }

}
